<div class="ui active inverted dimmer" *ngIf="loader">
    <div class="ui text loader"></div>

   

  </div>
<router-outlet></router-outlet>
<footer class="foo">V-{{version}}</footer>
